"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const ussdBankList_1 = __importDefault(require("../../ussdBankList/ussdBankList"));
const theme_1 = __importDefault(require("../../../styles/theme"));
const constants_1 = require("../../../constants/constants");
const ussdBankViewStyles_1 = __importDefault(require("./ussdBankViewStyles"));
const text_1 = __importStar(require("../../text/text"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const textStyles_1 = __importDefault(require("../../text/textStyles"));
const messageCard_1 = __importDefault(require("../../messageCards/messageCard"));
const UssdBankView = ({ installment, ussdBankAccountList }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(messageCard_1.default, { warning: {
                headline: 'When we receive your bank transfer, your amount due will be updated.',
            } }),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, t('ussdBankView.select_bank')),
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('ussdBankView.connection'))),
        react_1.default.createElement(ussdBankList_1.default, { ussdBankAccountList: ussdBankAccountList }),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow, ussdBankViewStyles_1.default.borderTop] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexThree] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, `Installment #${installment.id} amount:`)),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: textStyles_1.default.bold }, `${constants_1.NAIRA_SYMBOL}${installment.amount_remaining}`)))));
};
exports.default = UssdBankView;
